"use client";
import { Button } from "@nextui-org/react";
import Link from "next/link";
import download from "@/data/dnlData.json";


const AppsScreen = () => {
  const { android, ios, tv } = download;
  return (
    <div className="container mx-auto flex pt-32 w-full h-auto">
      <div className="flex flex-col items-start justify-start max-w-full gap-8">
        <img src={"/apps/main-pic.png"} className="mx-auto" alt="" />
        {/* android section */}
        <div className="flex flex-col lg:flex-row w-full bg-[#101010] px-7 md:px-16 lg:px-24 py-5 lg:py-10 gap-20 lg:gap-0">
          <div className="flex flex-col w-full lg:w-2/5 gap-3 mt-5 items-center lg:items-start">
            <img
              src={"/apps/android-avatar.svg"}
              className="w-8 h-8 md:w-10 md:h-10 lg:w-[48px] lg:h-[48px]"
              alt="android"
            />
            <p className="text-base lg:text-xl text-[rgba(226, 226, 226, 1)] font-medium">
              اپلیکیشن موبایل و تبلت اندروید
            </p>
            <p className="text-xs lg:text-sm text-[rgba(226, 226, 226, 1)] font-medium text-center md:text-right">
              اپلیکیشن اندروید منه باخ را می‌توانید از طریق دکمه‌ زیر دریافت
              نمایید.
            </p>
            <div className="flex flex-col lg:flex-row gap-4 flex-wrap pt-5 w-full">
              <Link href={android.lastVertion} target="_blank">
                <Button
                  className="text-[rgba(21,21,21,1)] bg-white text-xs md:text-sm w-full lg:w-48"
                  startContent={
                    <img src={"/apps/dnl-icon.svg"} alt="download" />
                  }
                  key="lastVersion"
                  size="md"
                >
                  دانلود آخرین نسخه
                </Button>
              </Link>

              <Link target="_blank" href={android.bazar}>
                <Button
                  className="text-[rgba(226, 226, 226, 1)] text-[11px] md:text-xs w-full lg:w-48"
                  startContent={
                    <img
                      src={"/apps/cafe_bazaar_basket.svg"}
                      alt="cafe_bazaar_typo"
                    />
                  }
                  key="bazar"
                  size="md"
                >
                  <div className="flex gap-2 justify-center items-center">
                    دانلود از
                    <img
                      src={"/apps/cafe_bazaar_typo.png"}
                      width={40}
                      alt="cafe_bazaar_typo"
                    />
                  </div>
                </Button>
              </Link>

              <Link target="_blank" href={android.myket}>
                <Button
                  className="text-[rgba(226, 226, 226, 1)] text-[11px] md:text-xs w-full lg:w-48"
                  startContent={
                    <img src={"/apps/myket_icon.svg"} alt="myket" />
                  }
                  key="myket"
                  size="md"
                >
                  <div className="flex gap-2 justify-center items-center">
                    دانلود از
                    <img
                      src={"/apps/myket_typo.png"}
                      width={50}
                      alt="myket_typo"
                    />
                  </div>
                </Button>
              </Link>
            </div>
          </div>
          <div className="bg-[url(/apps/bg-gradient.svg)] w-full lg:w-3/5 bg-contain bg-center bg-no-repeat flex justify-center items-center">
            <img
              src={"/apps/android-section.png"}
              alt="picture"
              className="w-full"
            />
          </div>
        </div>
        {/* ios section */}
        <div className="flex flex-col-reverse lg:flex-row w-full items-end px-7 md:px-16 lg:px-24 md:pt-3 md:pb-8 gap-14 md:gap-20 lg:gap-0">
          <div className="bg-[url(/apps/bg-gradient.svg)] w-full lg:w-3/5 bg-contain bg-center bg-no-repeat flex justify-center items-center">
            <img
              src={"/apps/ios-section.png"}
              alt="picture"
              className="w-full"
            />
          </div>
          <div className="flex flex-col w-full lg:w-2/5 gap-4 lg:mt-5 items-center lg:items-start">
            <div className="flex gap-2 items-end justify-start">
              <img
                src={"/apps/apple-icon.svg"}
                className="w-7 h-7 md:w-9 md:h-9 lg:w-[45px] lg:h-[45px]"
                alt="ios"
              />
              <p className="text-base lg:text-2xl text-[rgba(226, 226, 226, 1)] font-medium h-5 lg:h-8">
                iOS
              </p>
            </div>
            <p className="text-xs lg:text-sm text-[rgba(226, 226, 226, 1)] font-medium pt-2">
              منه باخ برای iOS را می‌توانید از طریق دکمه‌های زیر دریافت نمایید
            </p>
            <div className="flex flex-col lg:flex-row gap-4 flex-wrap pt-5 w-full">
              {/* <Button
                className="text-[rgba(21,21,21,1)] bg-white text-xs md:text-sm w-full lg:w-48"
                startContent={<img src={"/apps/dnl-icon.svg"} alt="download" />}
                key="webApp"
                size="md"
              >
                <Link href={ios.webApp}>دریافت نسخه وب‌اپ</Link>
              </Button> */}
              <Button
                className="text-[rgba(226, 226, 226, 1)] text-[11px] md:text-xs w-full lg:w-48"
                startContent={
                  <img src={"/apps/sibapp_icon.svg"} alt="sibapp_icon" />
                }
                key="sibapp"
                size="md"
              >
                <Link
                  href={ios.sibApp}
                  className="flex gap-2 justify-center items-center"
                >
                  دانلود از
                  <img
                    src={"/apps/sibapp_typo.png"}
                    width={60}
                    alt="sibapp_typo"
                  />
                </Link>
              </Button>
              <Link target="_blank" href={ios.sibche}>
                <Button
                  className="text-[rgba(226, 226, 226, 1)] text-[11px] md:text-xs w-full lg:w-48"
                  startContent={
                    <img src={"/apps/sibche_icon.svg"} alt="sibapp_icon" />
                  }
                  key="sibche"
                  size="md"
                >
                  <div className="flex gap-2 justify-center items-center">
                    دانلود از
                    <img
                      src={"/apps/sibche_typo.svg"}
                      width={60}
                      alt="sibche_typo"
                    />
                  </div>
                </Button>
              </Link>

              <Link target="_blank" href={ios.iapps}>
                <Button
                  className="text-[rgba(226, 226, 226, 1)] text-[11px] md:text-xs w-full lg:w-48"
                  startContent={
                    <img src={"/apps/iapps_icon.svg"} alt="iapps" />
                  }
                  key="anardooni"
                  size="md"
                >
                  <div className="flex gap-2 justify-center items-center">
                    دانلود از
                    <img
                      src={"/apps/iapps_typo.png"}
                      width={60}
                      alt="iapps-typo"
                    />
                  </div>
                </Button>
              </Link>

              <Link target="_blank" href={ios.sibeirani}>
                <Button
                  className="text-[rgba(226, 226, 226, 1)] text-[11px] md:text-xs w-full lg:w-48"
                  startContent={
                    <img src={"/apps/sibirani_icon.svg"} alt="sibirani" />
                  }
                  key="anardooni"
                  size="md"
                >
                  <div className="flex gap-2 justify-center items-center">
                    دانلود از
                    <img
                      src={"/apps/sibirani_typo.png"}
                      width={60}
                      alt="sibirani_typo"
                    />
                  </div>
                </Button>
              </Link>
            </div>
          </div>
        </div>
        {/* tv section */}
        <div className="flex flex-col w-full bg-[#101010] px-7 md:px-16 lg:px-24 py-10">
          <div className="flex flex-col gap-3 justify-center items-center">
            <p className="text-base lg:text-xl font-medium text-[#E2E2E2]">
              منه باخ را روی تلویزیون تماشا کنید
            </p>
            <p className="text-xs lg:text-sm font-medium text-[#E2E2E2] text-center md:text-right">
              برای تماشای منه باخ روی صفحه بزرگ تلویزیون، از طریق زیر اقدام
              کنید.
            </p>
          </div>
          <div className="flex flex-col-reverse lg:flex-row lg:justify-between gap-5 w-full pt-8">
            <div className="flex flex-col w-full lg:w-3/5 gap-3 mt-10 lg:mt-20 text-center lg:text-right">
              <p className="text-base text-[rgba(226, 226, 226, 1)] font-medium">
                تلویزیون‌های مجهز به اندروید
              </p>
              <p className="text-xs lg:text-sm text-[rgba(226, 226, 226, 1)] font-medium">
                اگر دستگاه شما سیستم عامل اندروید دارد، روی دکمه زیر بزنید و
                اپلیکیشن منه باخ مخصوص تلویزیون را{" "}
                <br className="lg:flex hidden" />
                روی دستگاه خود دانلود و نصب کنید.
              </p>
              <div className="w-full flex flex-col lg:flex-row lg:justify-between flex-wrap lg:flex-nowrap pt-5 gap-4">
                <Link
                  target="_blank"
                  href={tv.directDownload}
                  className="w-full"
                >
                  <Button
                    className="text-[rgba(21,21,21,1)] bg-white text-xs md:text-sm w-full lg:flex-auto"
                    startContent={
                      <img
                        width={20}
                        height={20}
                        src={"/apps/dnl-icon.svg"}
                        alt="download"
                      />
                    }
                    key="directDownload"
                    size="md"
                  >
                    دانلود مستقیم
                  </Button>
                </Link>

                <Link href={tv.bazar} target="_blank" className="w-full">
                  <Button
                    className="text-[rgba(226, 226, 226, 1)] text-[11px] md:text-xs w-full lg:flex-auto"
                    startContent={
                      <img
                        src={"/apps/cafe_bazaar_basket.svg"}
                        alt="cafe_bazaar_typo"
                        width={21}
                        height={21}
                      />
                    }
                    key="bazar"
                    size="md"
                  >
                    <div className="flex gap-2 justify-center items-center">
                      دانلود از
                      <img
                        src={"/apps/cafe_bazaar_typo.png"}
                        width={40}
                        height={26}
                        alt="cafe_bazaar_typo"
                      />
                    </div>
                  </Button>
                </Link>

                <Link href={tv.myket} target="_blank" className="w-full">
                  <Button
                    className="text-[rgba(226, 226, 226, 1)] text-[11px] md:text-xs w-full lg:flex-auto"
                    startContent={
                      <img
                        src={"/apps/myket_icon.svg"}
                        width={22}
                        height={22}
                        alt="myket"
                      />
                    }
                    key="myket"
                    size="md"
                  >
                    <div className="flex gap-2 justify-center items-center">
                      دانلود از
                      <img
                        src={"/apps/myket_typo.png"}
                        width={50}
                        height={19}
                        alt="myket_typo"
                      />
                    </div>
                  </Button>
                </Link>
              </div>
              <Link href={tv.smartTv} target="_blank" className="w-full">
                <Button
                  className="text-[rgba(21,21,21,1)] bg-white text-xs md:text-sm w-full"
                  startContent={
                    <img
                      width={20}
                      height={20}
                      src={"/apps/dnl-icon.svg"}
                      alt="download"
                    />
                  }
                  key="download"
                  size="md"
                >
                  تلویزیون های هوشمند سامسونگ و LG
                </Button>
              </Link>
            </div>
            <div className="bg-[url(/apps/bg-gradient.svg)] w-full lg:w-2/5 bg-contain bg-left bg-no-repeat flex justify-center items-center">
              <img
                width={435}
                height={271}
                src={"/apps/tv-section.png"}
                alt="picture"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppsScreen;
